// Paletas del dashboard general. Las donas reciben el color ya asignado en
// cada item (ver utils.js), para que leyenda, tooltip y porcion coincidan.
export const COLOR_VENTAS = "#2563eb";
export const COLOR_COMPRAS = "#22c55e";
export const COLOR_SIN_DATOS = "#e5e7eb";

// Los estados conocidos mantienen siempre el mismo color; cualquier otro
// estado que mande el backend toma un color de COLORES_ESTADO_OTROS.
export const COLORES_ESTADO = {
    REGISTRADO: "#2563eb",
    APROBADO: "#22c55e",
    EMITIDO: "#22c55e",
    RECHAZADO: "#fbbf24",
    ANULADO: "#cbd5e1",
};
export const COLORES_ESTADO_OTROS = ["#8b5cf6", "#06b6d4", "#64748b", "#ec4899"];

// Tramos de antiguedad de la cuenta por cobrar, en el orden en que se
// muestran. "claves" son los textos (normalizados) que puede mandar el backend.
export const TRAMOS_CUENTA_COBRAR = [
    { nombre: "Al corriente", color: "#22c55e", claves: ["AL CORRIENTE", "CORRIENTE", "VIGENTE"] },
    { nombre: "1 - 30 días", color: "#2563eb", claves: ["1 - 30 DIAS", "1-30 DIAS"] },
    { nombre: "31 - 60 días", color: "#fbbf24", claves: ["31 - 60 DIAS", "31-60 DIAS"] },
    { nombre: "> 60 días", color: "#ef4444", claves: ["> 60 DIAS", ">60 DIAS", "MAS DE 60 DIAS"] },
];

export const NOMBRES_MES_CORTO = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];

// TODO: datos en duro mientras el backend del Resumen Financiero esta en
// desarrollo. Reemplazar por el bloque "resumenFin" del servicio cuando
// traiga la informacion real.
export const RESUMEN_FINANCIERO_EN_DURO = {
    ingresos: { pen: 245680, usd: 65515 },
    gastos: { pen: 167430, usd: 44648 },
};
